import * as Yup from "yup";

export const facturarTareaSchema = Yup.object().shape({
  tipoFacturacion: Yup.string()
    .oneOf(["MismaEmpresa", "OtraEmpresa"])
    .required(),

  rutReceptor: Yup.string().when("tipoFacturacion", {
    is: "OtraEmpresa",
    then: Yup.string().required("RUT del receptor requerido"),
    otherwise: Yup.string().notRequired(),
  }),
  razonSocialReceptor: Yup.string().when("tipoFacturacion", {
    is: "OtraEmpresa",
    then: Yup.string().required("Razón social requerida"),
    otherwise: Yup.string().notRequired(),
  }),
  direccionReceptor: Yup.string().when("tipoFacturacion", {
    is: "OtraEmpresa",
    then: Yup.string().required("Dirección requerida"),
    otherwise: Yup.string().notRequired(),
  }),
  comunaReceptor: Yup.string().when("tipoFacturacion", {
    is: "OtraEmpresa",
    then: Yup.string().required("Comuna requerida"),
    otherwise: Yup.string().notRequired(),
  }),
  giroReceptor: Yup.string().notRequired(),

  glosa: Yup.string()
    .trim()
    .min(1, "Glosa requerida")
    .max(80, "Máximo 80 caracteres")
    .required("Glosa requerida"),
  descripcion: Yup.string().max(1000, "Máximo 1000 caracteres").nullable(),

  abono: Yup.string().oneOf(["SI", "NO"]).required(),
  porcentaje: Yup.number()
    .transform((value, original) =>
      original === "" || original === null ? undefined : value,
    )
    .when("abono", {
      is: "SI",
      then: Yup.number()
        .typeError("Porcentaje inválido")
        .min(1, "Mínimo 1%")
        .max(100, "Máximo 100%")
        .required("Porcentaje requerido"),
      otherwise: Yup.number().notRequired(),
    }),
  montoFacturar: Yup.number()
    .transform((value, original) =>
      original === "" || original === null ? undefined : value,
    )
    .typeError("Monto inválido")
    .positive("El monto debe ser mayor a 0")
    .test(
      "no-supera-restante",
      "El monto supera el total restante",
      function (value) {
        if (value === undefined || value === null) return true;
        const totalRestante = this.parent?._meta?.totalRestanteCLP ?? 0;
        const MARGEN_REDONDEO = 2;
        return Number(value) <= totalRestante + MARGEN_REDONDEO;
      },
    )
    .required("Monto requerido"),
  formatoPago: Yup.string().oneOf(["1", "2", "3"]).required(),

  _meta: Yup.object().shape({
    valorTipoMoneda: Yup.number()
      .moreThan(0, "Valor de la moneda no disponible")
      .required(),
  }),
});
